import hyperdom from 'hyperdom'
import BasePaymentMethod from '../methods/basePaymentMethod.jsx'
import isScriptLoaded from 'root-core/isScriptLoaded'

export default class PaymentGateway extends BasePaymentMethod{
  constructor (payment, fastTrack = false) {
    super(payment)
    this.user = payment.user
    this.passengerDetails = payment.quoteCriteria.leadPassenger
    this.paymentGatewayUrl = payment.config.paymentGatewayUrl
    this.fastTrack = fastTrack
    this.datadog = payment.datadog
    this.injectScript()
  }

  amount () {}

  paymentOptionName () {}

  paymentOptionTestData () {}

  isPriceDiscount () {}

  renderPrice () {}

  failed () {
    this.payment.hideLoading()
  }

  success (response) {
    this.payment.serverErrorsPanel.clear()
    this.payment.booking.paidViaPaymentGateway(response)
    this.payment.switchToTab('confirmation')
    this.payment.hideLoading()
    this.payment.refresh()
  }

  paymentGatewayResponseHandler (response) {
    if (response && response.paymentSuccessful) {
      this.success(response)
    } else {
      this.failed()
    }
  }

  paymentGatewayContainer () {
    if (this.payment.paymentOption() === this) {
      return <div id="payment-gateway-component" className="u-margin-top-small"></div>
    }
  }

  updateOptionsAndRender () {
    this.options = {
      sellingCompany: this.payment.departure.sellingCompanyCode,
      agencyId: this.user.agencyId,
      transactionInfo: {
        transactionId: this.payment.booking.booking.bookingId,
        fastTrack: `${this.fastTrack}`,
        firstName: this.passengerDetails.firstName,
        lastName: this.passengerDetails.lastName,
        phone: this.passengerDetails.phoneNumber.areaCode + this.passengerDetails.phoneNumber.number,
        email: this.passengerDetails.emailAddress,
        addressLine1: this.passengerDetails.address.line1,
        addressLine2: this.passengerDetails.address.line2,
        addressCity: this.passengerDetails.address.city,
        addressStateName: this.passengerDetails.address.region,
        addressPostalCode: this.passengerDetails.address.postcode,
        addressCountry: this.passengerDetails.address.country && Object.keys(this.payment.countries()).find(code => this.payment.countries()[code].name === this.passengerDetails.address.country).toUpperCase(),
        amount: String(this.amount()),
        currency: this.payment.departure.prices.currency,
        bookingType: this.user.isTravelAgent ? 'TA' : 'CD',
        tripName: this.payment.departure.name,
      },
    }
    this.attachPaymentOptions()
  }


  attachPaymentOptions () {
    this.payment.hideLoading()
    window.ttcPaymentgateway.attachPaymentOption(JSON.stringify(this.options),`#payment-gateway-component`, (response) => this.paymentGatewayResponseHandler(response))
  }

  onrender () {
    const paymentGatewayElement = document.getElementById('payment-gateway-component')
    if(paymentGatewayElement && !paymentGatewayElement.firstChild && window.ttcPaymentgateway && this.payment.paymentOption() === this) {
      this.updateOptionsAndRender()
    }
    if(this.payment.paymentOption() === this && this.options === undefined && !PaymentGateway.loadingFailed) {
      this.payment.showLoading()
    }
  }

  render () {
    return <label
      data-test={this.paymentOptionTestData()}
      class={['o-choice-item payment-options__item', {
        'has-discounts': this.payment.anyDiscounts(),
        '-selected': PaymentGateway.loadingFailed ? false : this.payment.paymentOption() === this,
      }]}
    >
      {PaymentGateway.loadingFailed ? this.renderErrorRibbon() : ''}
      <input type='radio' class='o-choice-item__radio' name='payment-type'
        binding={[this.payment.paymentOptions, 'selected']}
        disabled={PaymentGateway.loadingFailed}
        value={PaymentGateway.loadingFailed ? false : this}/>
      <div className={['o-choice-item__content payment-option__container', PaymentGateway.loadingFailed ? ' disabled' : '']}>
        <div>
          <div className='payment-option__title'>
            <div className='payment-option__title__header'>{this.paymentOptionName()}</div>
            {PaymentGateway.loadingFailed ? <div>Please try again later.</div>: ''}
          </div>
        </div>
        <div>
          {this.renderPrice()}
        </div>
      </div>
      <div className={['payment-option__methods-container', {'show-expanded': this.payment.paymentOption() === this}]}>
        {PaymentGateway.loadingFailed ? undefined : this.paymentGatewayContainer()}
      </div>
    </label>
  }

  renderDiscountRibbon () {
    return ''
  }

  renderErrorRibbon () {
    return <span className='ribbon -right payment-option__ribbon--unavailable'>TEMPORARILY UNAVAILABLE</span>
  }

  injectScript () {
    if (!isScriptLoaded(this.paymentGatewayUrl)) {
      PaymentGateway.loadingFailed = false
      const paymentGatewayScript = document.createElement('script')
      paymentGatewayScript.src = this.paymentGatewayUrl
      paymentGatewayScript.onerror = () => {
        PaymentGateway.loadingFailed = true
        this.payment.hideLoading()
        this.datadog.error(`Error while loading PaymentGateway`)
      }
      document.head.appendChild(paymentGatewayScript)
    }
  }
}
